export const PROJECT_NAV_ITEMS = [
  { id: "overview", to: "/overview", label: "Overview" },
  { id: "board", to: "/board", label: "Board" },
  { id: "backlog", to: "/backlog", label: "Backlog" },
  { id: "table", to: "/table", label: "Table" },
  { id: "roadmap", to: "/roadmap", label: "Roadmap" },
  { id: "calendar", to: "/calendar", label: "Calendar" },
  { id: "docs", to: "/docs", label: "Docs" },
  { id: "bugs", to: "/bugs", label: "Bug triage" },
  { id: "mywork", to: "/mywork", label: "My work" },
  { id: "trash", to: "/trash", label: "Trash" },
  { id: "search", to: "/search", label: "Search" }
] as const;
